declare namespace $ {

	type $mol_view__sub_bog_worm_panel_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_check_list__options_bog_worm_panel_2 = $mol_type_enforce<
		({ 
			'sensory': string,
			'poly': string,
			'inter': string,
			'motor': string,
			'muscle': string,
			'other': string,
		}) 
		,
		ReturnType< $mol_check_list['options'] >
	>
	type $mol_check_list__option_checked_bog_worm_panel_3 = $mol_type_enforce<
		ReturnType< $bog_worm_panel['type_on'] >
		,
		ReturnType< $mol_check_list['option_checked'] >
	>
	type $mol_view__sub_bog_worm_panel_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_worm_panel_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_check_list__options_bog_worm_panel_6 = $mol_type_enforce<
		({ 
			'chemical': string,
			'gap': string,
		}) 
		,
		ReturnType< $mol_check_list['options'] >
	>
	type $mol_check_list__option_checked_bog_worm_panel_7 = $mol_type_enforce<
		ReturnType< $bog_worm_panel['kind_on'] >
		,
		ReturnType< $mol_check_list['option_checked'] >
	>
	type $mol_view__sub_bog_worm_panel_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_worm_panel_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_worm_slider__hint_bog_worm_panel_10 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_worm_slider['hint'] >
	>
	type $bog_worm_slider__least_bog_worm_panel_11 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_worm_slider['least'] >
	>
	type $bog_worm_slider__most_bog_worm_panel_12 = $mol_type_enforce<
		ReturnType< $bog_worm_panel['weight_most'] >
		,
		ReturnType< $bog_worm_slider['most'] >
	>
	type $bog_worm_slider__value_bog_worm_panel_13 = $mol_type_enforce<
		ReturnType< $bog_worm_panel['weight_min'] >
		,
		ReturnType< $bog_worm_slider['value'] >
	>
	type $mol_view__sub_bog_worm_panel_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_worm_panel_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_search__hint_bog_worm_panel_16 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_search['hint'] >
	>
	type $mol_search__query_bog_worm_panel_17 = $mol_type_enforce<
		ReturnType< $bog_worm_panel['path_from'] >
		,
		ReturnType< $mol_search['query'] >
	>
	type $mol_search__suggests_bog_worm_panel_18 = $mol_type_enforce<
		ReturnType< $bog_worm_panel['path_from_suggests'] >
		,
		ReturnType< $mol_search['suggests'] >
	>
	type $mol_search__hint_bog_worm_panel_19 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_search['hint'] >
	>
	type $mol_search__query_bog_worm_panel_20 = $mol_type_enforce<
		ReturnType< $bog_worm_panel['path_to'] >
		,
		ReturnType< $mol_search['query'] >
	>
	type $mol_search__suggests_bog_worm_panel_21 = $mol_type_enforce<
		ReturnType< $bog_worm_panel['path_to_suggests'] >
		,
		ReturnType< $mol_search['suggests'] >
	>
	type $mol_view__sub_bog_worm_panel_22 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_worm_panel_23 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_worm_panel_24 = $mol_type_enforce<
		ReturnType< $bog_worm_panel['legend'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__attr_bog_worm_panel_25 = $mol_type_enforce<
		({ 
			'worm_type': ReturnType< $bog_worm_panel['legend_type'] >,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__sub_bog_worm_panel_26 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_worm_panel extends $mol_view {
		cells_title( ): string
		Cells_title( ): $mol_view
		type_on( id: any, next?: boolean ): boolean
		Types( ): $mol_check_list
		Cells( ): $mol_view
		links_title( ): string
		Links_title( ): $mol_view
		kind_on( id: any, next?: boolean ): boolean
		Kinds( ): $mol_check_list
		Links( ): $mol_view
		weight_title( ): string
		Weight_title( ): $mol_view
		weight_most( ): number
		weight_min( next?: number ): number
		Weight_slider( ): $bog_worm_slider
		Weight( ): $mol_view
		path_title( ): string
		Path_title( ): $mol_view
		path_from( next?: string ): string
		path_from_suggests( ): readonly(string)[]
		Path_from( ): $mol_search
		path_to( next?: string ): string
		path_to_suggests( ): readonly(string)[]
		Path_to( ): $mol_search
		path_note( ): string
		Path_note( ): $mol_view
		Path( ): $mol_view
		legend( ): readonly(any)[]
		Legend( ): $mol_view
		legend_type( id: any): string
		Legend_dot( id: any): $mol_view
		legend_label( id: any): string
		sub( ): readonly(any)[]
		Legend_row( id: any): $mol_view
	}
	
}

//# sourceMappingURL=panel.view.tree.d.ts.map